<template>
  <div class="custom-input textarea row">
    <fa v-if="faClass" :fa-class="faClass" class="vh-align" />
    <div :class="getColClass">
      <div v-if="label" :class=" getLabelClass">
        {{ $t(label) }}
      </div>

      <textarea :name="name" rows="4" v-model="val"
                :required="required" :placeholder="placeholder"
      />
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'

export default {
  components: {
    fa,
    bFormInput,
    error
  },

  mixins: [formMethods],

  props: {
    name: {
      type: String,
      required: true
    },
    faClass: String,
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      val: this.value,
      displayError: false,
      errorMessage: ''
    }
  },

  computed: {
    getColLabelClass () {
      return this.faClass ? '' : 'offset-2'
    }
  },

  watch: {
    val (newVal, oldVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
